module.exports = __webpack_public_path__ + "static/media/Gotham-MediumItalic.47640c7b.woff";